<app-image-cropper-popup [roundCropper]="isLogo" [isVisible]="showCropper" [image]="file" (submitImage)="uploadDraftImage($event)"
    (cancelEvent)="cancel()"></app-image-cropper-popup>

<div class="image-panel">
    <ng-container *ngIf="isLoading; then loadingTemplate; else imageTemplate"></ng-container>
</div>

<ng-template #loadingTemplate>
    <app-loader></app-loader>
</ng-template>

<ng-template #imageTemplate>
    <div *ngIf="image; then mainTemplate; else alternativeTemplate"></div>
</ng-template>

<ng-template #mainTemplate>
    <div class="image-preview">
        <img [src]="image" (error)="onImgError($event)" [class.round-image]="isLogo" [class.max-140]="!isLogo" [class.edit-mode]="!isDisabled"
            [class.centered]="centered">
        <div *ngIf="canRemove; then removeButtonTemplate"></div>
        <div *ngIf="canAdd; then addButtonTemplate"></div>
    </div>
</ng-template>

<ng-template #alternativeTemplate>
    <div class="default-image" [class.round-image]="isLogo" [class.edit-mode]="!isDisabled" [class.centered]="centered">
        <img *ngIf="!image && isDisabled" [src]="defaultImgPath" [class.round-image]="isLogo" />
        <div *ngIf="!isDisabled && canAdd; then addButtonTemplate"></div>
    </div>
</ng-template>

<ng-template #addButtonTemplate>
    <ng-container *ngIf="!isDisabled && !image">
        <button class="add-new-image-button" (click)="file.click()">
            <div class="file-input">
                <i class=" add-image fas fa-plus-circle"></i>
                <div class="file-input__add-image-label">
                    {{'image-upload.add-new-image'|translate }} max. {{maxFileSize}}
                </div>
            </div>
            <input #file id="{{ id }}" type="file" accept=".png, .jpg, .jpeg" (change)="imageSelected(file.files)" />
        </button>
    </ng-container>
</ng-template>

<ng-template #removeButtonTemplate>
    <ng-container *ngIf="!isDisabled && image">
        <span (click)="removeImage()" class="delete-image" [class.delete-logo-image]="isLogo" [class.position-right-top]="centered"> <i
                class="fa fa-times-circle"></i> </span>
    </ng-container>
</ng-template>
